/**
 * My API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmploymentConditionLibraryAttributesAttributeValueModel } from './employment-condition-library-attributes-attribute-value-model';
import { EmploymentConditionLibraryAttributesEntityDataSourceModel } from './employment-condition-library-attributes-entity-data-source-model';
import { SiemensEnergyCOINEmploymentConditionLibraryApiDtosUsersUserResponse } from './siemens-energy-coin-employment-condition-library-api-dtos-users-user-response';

export interface EmploymentConditionLibraryAttributesStandardAttributeModel {
  id?: string;
  name: string | null;
  country?: string | null;
  legalEntity?: string | null;
  type?: EmploymentConditionLibraryAttributesStandardAttributeModelTypeEnum;
  isPlaceholder?: boolean;
  isRuleRelevant?: boolean;
  isGlobal?: boolean;
  isTranslatable?: boolean;
  dataSources?: Array<EmploymentConditionLibraryAttributesEntityDataSourceModel> | null;
  sourceField?: string | null;
  hasPreviousValue?: boolean;
  isMultipleAssignmentAllowed?: boolean;
  values?: Array<EmploymentConditionLibraryAttributesAttributeValueModel> | null;
  hasValuesAssigned?: boolean | null;
  createdAt?: string;
  createdBy?: SiemensEnergyCOINEmploymentConditionLibraryApiDtosUsersUserResponse;
  updatedAt?: string;
  updatedBy?: SiemensEnergyCOINEmploymentConditionLibraryApiDtosUsersUserResponse;
  decimalFormat?: string | null;
  roundingMethod?: EmploymentConditionLibraryAttributesStandardAttributeModelRoundingMethodEnum | null;
  effectiveTo?: string | null;
  isOverwritingCountryNumberSetting?: boolean;
}
export enum EmploymentConditionLibraryAttributesStandardAttributeModelTypeEnum {
  Text = 'Text',
  Number = 'Number',
  Date = 'Date',
  Boolean = 'Boolean',
  Country = 'Country',
  Currency = 'Currency',
  Percentage = 'Percentage'
}
export enum EmploymentConditionLibraryAttributesStandardAttributeModelRoundingMethodEnum {
  RoundHalfUp = 'RoundHalfUp',
  RoundHalfDown = 'RoundHalfDown',
  RoundHalfEven = 'RoundHalfEven',
  RoundUpCeiling = 'RoundUpCeiling',
  RoundDownFloor = 'RoundDownFloor'
}
